import React, { forwardRef } from 'react'
import { InputBase, type InputBaseProps } from '@instacart/ids-core'
import styled from '@emotion/styled'
import { colors } from '../..'

type Props = {
  decorationPosition?: 'left' | 'right'
  decorationComponent: React.ComponentType<{ className?: string }>
} & InputBaseProps

const Container = styled.div({
  position: 'relative',
})

export const DecoratedInput = forwardRef<HTMLInputElement, Props>(
  ({ decorationComponent: DecorationComponent, decorationPosition = 'left', ...props }, ref) => (
    <Container>
      <InputBase
        css={{ [decorationPosition === 'left' ? 'paddingLeft' : 'paddingRight']: 33 }}
        {...props}
        ref={ref}
      />
      <DecorationComponent
        css={{
          position: 'absolute',
          top: 9,
          width: 20,
          height: 20,
          [decorationPosition]: 8,
          fill: colors.GRAYSCALE.X50,
        }}
      />
    </Container>
  )
)
